export const ENUYGUN_GTM_CONTAINER_ID = 'GTM-PPNXR7C'
export const WINGIE_GTM_CONTAINER_ID = 'GTM-W53HFVD'

export const gtms: Record<string, string> = {
  tr: ENUYGUN_GTM_CONTAINER_ID,
  default: WINGIE_GTM_CONTAINER_ID,
}

/** Market → GTM container (TR = Enuygun, diğerleri = Wingie default). */
export function getGtmContainerId(market?: string): string {
  if (market && gtms[market]) return gtms[market]
  return gtms.default
}

/**
 * GTM bootstrap: first-party gateway (`/6wz7af34h/`, Wingie `/hhri/`) varsa onu bekler, yoksa
 * googletagmanager.com/gtm.js'e düşer. sGTM/GTG ile çift gtm.js yarışını önler
 * (core-frontend CAR-20046 / MR 1641 ile aynı yaklaşım).
 *
 * Fallback önce container id'sini `google_tags_first_party`'den çıkarır: CF GTG snippet'i id'yi oraya
 * yazar ve googletagmanager.com gtm.js sahiplenilmiş container'ı kaydetmez (gateway hatasında 0 hit).
 *
 * Standalone yalnızca `gtm.start` push'u kullanma — container'ı ayağa kaldırmaz.
 * Statik `<script src=".../gtm.js?id=...">` veya `@next/third-parties` GoogleTagManager
 * ekleme — bu IIFE fallback yüklemenin tek sahibi olmalı.
 */
export function getGtmBootstrapScript(containerId: string): string {
  return String.raw`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
var ready=function(){return !!(w.google_tag_manager&&w.google_tag_manager[i]);},done=false;
var fallback=function(){if(done||ready())return;done=true;
var fp=w.google_tags_first_party;if(fp&&fp.splice)for(var x=fp.length-1;x>=0;x--)if(fp[x]===i)fp.splice(x,1);
var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);};
if(ready())return;
var gw=null,ss=d.getElementsByTagName(s);
for(var k=0;k<ss.length;k++)if(/\/(6wz7af34h|hhri)\/(\?id=|$)/.test(ss[k].src)){gw=ss[k];break;}
if(!gw)return fallback();
var pe=w.performance&&performance.getEntriesByName(gw.src)[0];
if(pe&&pe.responseEnd)return setTimeout(fallback,0);
gw.addEventListener('load',fallback);gw.addEventListener('error',fallback);
setTimeout(fallback,10000);
})(window,document,'script','dataLayer','${containerId}');`
}
